import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-biglietteria',
  templateUrl: './biglietteria.component.html',
  styleUrls: ['./biglietteria.component.scss']
})
export class BiglietteriaComponent implements OnInit {
  public url: SafeResourceUrl;

  constructor(public dialogRef: MatDialogRef<BiglietteriaComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public sanitizer: DomSanitizer) {
                this.url = this.sanitizer.bypassSecurityTrustResourceUrl(data);
                console.log('URL', this.url);
              }

  ngOnInit(): void {
    // const iframe = this.iframeElem.nativeElement; // this.hostElement.nativeElement.querySelector('iframe');
    // iframe.src = this.privacyUrl;
    
    
      // Opera/Mozilla/Webkit
      window.addEventListener('message',  (event: any) => {
        if (event.data === 'close') {
          this.dialogRef.close();
        }
      }, false);
    
    


  }
  public sanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url); // bypassSecurityTrustResourceUrl - bypassSecurityTrustUrl
  }
  public close() {
    this.dialogRef.close();
  }
}
